/** Current wire schema version. Bump on breaking envelope changes. */
export const SCHEMA_VERSION = 1;
//# sourceMappingURL=session.js.map